import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { mgcIconStopFilled } from '@sb/mgc-icons/mgcIcon-stop_filled.icon';
import { IconComponent, IconRegistry } from '@sb/ui/icon';

@Component({
  selector: 'sb-profile-clock-out-item',
  imports: [TranslatePipe, RouterModule, IconComponent],
  template: `
    <a class="flex w-full px-2">
      <div
        [routerLink]="['', { outlets: { modal: ['clock'] } }]"
        class="flex flex-1 items-center gap-3 rounded bg-danger-subtle px-3.5 py-4 text-xl font-bold text-danger hover:bg-danger/15 xl:px-1.5 xl:py-2 xl:text-lg xl:font-semibold"
      >
        <sb-icon class="h-5 w-5 xl:h-4 xl:w-4" name="stop-filled" />
        {{ 'Clock-out' | translate }}
      </div>
    </a>
  `,
})
export class SBProfileClockOutItemComponent {
  constructor() {
    inject(IconRegistry).registerIcons([mgcIconStopFilled]);
  }
}
